import { isToss } from './platform';

/**
 * 서비스 워커 등록 (`/sw.js` — vite.config의 brandPlugin이 빌드 때 생성).
 *
 * 하는 일은 셋이다: 번들 자산과 카드 그림 78장을 캐시해 재방문을 빠르게, 방문했던 화면을
 * 오프라인에서도 뜨게, 아무것도 없으면 우리 안내 화면을 보여주기. `/api`는 손대지 않는다.
 *
 * **끄는 경우가 둘 있다.**
 *  - 개발 중: 워커가 옛 번들을 붙들고 있으면 HMR이 안 먹어 "고쳤는데 안 바뀐다"가 된다
 *  - 토스 미니앱: 번들이 이미 기기에 통째로 올라가 있어 캐시할 이유가 없고,
 *    심사를 통과한 번들 위에 캐시 계층을 하나 더 얹으면 문제를 재현하기만 어려워진다
 */
export function registerServiceWorker(): void {
  if (isToss || !import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  // 첫 화면 그리기와 경쟁하지 않도록 load 이후로 미룬다
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch((e) => {
      // 등록 실패는 기능 저하일 뿐 서비스 중단이 아니다 — 조용히 넘어간다
      console.warn('service worker 등록 실패:', e);
    });
  });
}
